'use strict';
import React, { Fragment } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Pagination } from "semantic-ui-react";
import SelectInput from "./SelectInput";
import Row from "./Row";
import Col from "./Col";
import ArrowLeftIcon from "../common/svg nado/ArrowLeftIcon";
import ArrowRightIcon from "../common/svg nado/ArrowRightIcon";

const Table = (props) => {
    const {
        headers,
        headerSizes,
        children,
        onClickHeader,
        sortableColumns,
        onPageChange,
        pageSize,
        totalPages,
        activePage,
        id,
        changePageSize,
        totalItems,
        title,
        containerMargin,
        setMinWidth,
        narrowHeaders,
        centeredColumns,
        columnIndexesToHideWhenResponsive,
        ignoreLastItemStyling
    } = props;

    let thInnerStyle = {
        position: 'absolute',
        top: 0,
        margin: '4px',
        display: 'block',
        textAlign: 'inherit'
    };

    if (narrowHeaders) {
        // thInnerStyle.width = 'inherit';
        thInnerStyle.overflowWrap = 'normal';
    }

    const headerBackgroundStyle = {
        backgroundColor: '#f9f9f9',
        height: narrowHeaders ? '50px' : '25px',
        borderTopLeftRadius: '4px',
        borderTopRightRadius: '4px'
    };

    const pageSizes = [
        { label: "20", value: 20 },
        { label: "50", value: 50 },
        { label: "100", value: 100 },
        { label: "250", value: 250 }
    ];

    const handleOnClickHeader = (index) => {
        if (sortableColumns && sortableColumns.indexOf(index) >= 0) {
            return function (event) {
                onClickHeader(index, event);
            };
        }
        else {
            return null;
        }
    };

    const getTableHeader = (header, i) => {
        const headerHasSmallOption = headerSizes.length > 0 && typeof headerSizes[i] === 'object';

        if (!headerHasSmallOption)
            return getHeaderForHeaderSize(header, i, headerSizes.length > 0 ? headerSizes[i] : null);
        else
            return [getHeaderForHeaderSize(header, i, headerSizes[i].size, 'u-display:none@to:viewport-7'), getHeaderForHeaderSize(header, i, headerSizes[i].smallSize, 'u-display:none@at:viewport-7')];
    };

    const getHeaderForHeaderSize = (header, i, headerSize, extraHeaderClassName) => {
        const headerStyle = {
            width: headerSize + '%'
        };

        let headerClass = columnIndexesToHideWhenResponsive && columnIndexesToHideWhenResponsive.find(x => x === i) ? 'u-display:none@to:viewport-9' : '';
        headerClass = 'c-table__header ' + headerClass;
        if (extraHeaderClassName)
            headerClass += " " + extraHeaderClassName;

        if (header.className)
            headerClass += " " + header.className;

        if (ignoreLastItemStyling)
            headerClass += " ignoreLastItemStyling";

        return <th title={header.title ? header.title : null} style={headerSize ? headerStyle : null} className={headerClass} onClick={handleOnClickHeader(i)} key={i}>{getHeaderTextSpans(header)} {sortableColumns && sortableColumns.indexOf(i) >= 0 ? <i className="fa fa-sort fa-fw" /> : null}</th>;
    };

    const getHeaderTextSpans = (header) => {
        return typeof header === 'object' ? header.text : header;
    };

    const newPaging = () => {
        if (pageSize && activePage && totalItems)
            return <div id="root">
                <div className="sb-styles:padding">
                    <div className="c-pagination ">
                        <nav className="c-pagination__navigation" aria-label="pagination">
                            <button className={
                                classNames({
                                    'c-button': true,
                                    'c-pagination__button': true,
                                    'c-pagination__button--prev': true,
                                    'u-display:none@to:viewport-7': true,
                                    'is-disabled': activePage === 1
                                })}
                                onClick={activePage === 1 ? () => { } : () => onPageChange(activePage - 1)}>
                                <span className="c-icon c-button__icon c-button__icon--before" aria-hidden="true" focusable="false">
                                    {<ArrowLeftIcon />}
                                </span>
                                <span className="c-button__text">
                                    Vorige
                                </span>
                            </button>
                            <button className={
                                classNames({
                                    'c-button': true,
                                    'c-pagination__button': true,
                                    'c-pagination__button--prev': true,
                                    'u-display:none@at:viewport-7': true,
                                    'is-disabled': activePage === 1,
                                    'c-button--icon-only': true
                                })}
                                onClick={activePage === 1 ? () => { } : () => onPageChange(activePage - 1)}>
                                <span className="c-icon c-button__icon c-button__icon--before" aria-hidden="true" focusable="false">
                                    {<ArrowLeftIcon />}
                                </span>
                                <span className="c-button__text">
                                </span>
                            </button>
                            <ul className="c-pagination__list">
                                {activePage === 1 || activePage === 2 ? '' :
                                    <li className="c-pagination__item">
                                        <a className="c-pagination__link" onClick={() => onPageChange(1)}>1</a>
                                    </li>
                                }
                                {activePage === 1 || activePage === 2 || activePage === 3 ? '' :
                                    <li className="c-pagination__item  u-display:none@to:viewport-9 ">
                                        <a className="c-pagination__link">...</a>
                                    </li>}
                                {activePage === 1 ? '' :
                                    <li className="c-pagination__item u-display:none@at:viewport-4">
                                        <a className="c-pagination__link" onClick={() => onPageChange(activePage - 1)}>{activePage - 1}</a>
                                    </li>}
                                <li className="c-pagination__item is-active">
                                    <a className="c-pagination__link" onClick={() => onPageChange(activePage)}>{activePage}</a>
                                </li>
                                {activePage === totalPages ? '' :
                                    <li className="c-pagination__item u-display:none@at:viewport-4">
                                        <a className="c-pagination__link" onClick={() => onPageChange(activePage + 1)}>{activePage + 1}</a>
                                    </li>}
                                {activePage === totalPages || activePage === totalPages - 1 ? '' :
                                    <li className="c-pagination__item  u-display:none@to:viewport-9 ">
                                        <a className="c-pagination__link">...</a>
                                    </li>}
                                {activePage === totalPages || activePage === totalPages - 1 ? '' :
                                    <li className="c-pagination__item">
                                        <a className="c-pagination__link" onClick={() => onPageChange(totalPages)}>{totalPages}</a>
                                    </li>
                                }
                            </ul>
                            <button
                                className={
                                    classNames({
                                        'c-button': true,
                                        'c-pagination__button': true,
                                        'c-pagination__button--next': true,
                                        'u-display:none@to:viewport-7': true,
                                        'is-disabled': activePage === totalPages
                                    })} onClick={activePage === totalPages ? () => { } : () => onPageChange(activePage + 1)}>
                                <span className="c-button__text">
                                    Volgende
                        </span>
                                <span className="c-icon c-button__icon c-button__icon--after" aria-hidden="true" focusable="false">
                                    {<ArrowRightIcon />}
                                </span>
                            </button>
                            <button
                                className={
                                    classNames({
                                        'c-button': true,
                                        'c-pagination__button': true,
                                        'c-pagination__button--next': true,
                                        'u-display:none@at:viewport-7': true,
                                        'is-disabled': activePage === totalPages,
                                        'c-button--icon-only': true
                                    })} onClick={activePage === totalPages ? () => { } : () => onPageChange(activePage + 1)}>
                                <span className="c-icon c-button__icon c-button__icon--before" aria-hidden="true" focusable="false">
                                    {<ArrowRightIcon />}
                                </span>
                                <span className="c-button__text">
                                </span>
                            </button>
                        </nav>
                        {totalItems ?
                            <p className="c-pagination__info">
                                {pageSize * (activePage - 1) + 1}-{(pageSize * activePage) > totalItems ? totalItems : (pageSize * activePage)} van de {totalItems} resultaten
                        </p> : null}
                    </div>
                </div>
            </div >;
        return '';
    };

    const pageSizeStyle = { 'marginTop': '20px', 'color': '#777', 'fontSize': '14px', 'float': 'left' };

    const pageSizePicker = changePageSize ?
        <Col size={6} className="u-display:none@to:viewport-4">
            <div style={{ 'white-space': 'nowrap', width: '166px', float: 'right' }}>
                <p style={{ 'display': 'inline-block', width: '34px' }}>Toon</p>
                <div style={{ 'display': 'inline-block', width: '66px' }}>
                    <SelectInput style={{ 'display': 'inline-block', width: '50px' }}
                        items={pageSizes}
                        name="pageSize"
                        defaultItemVisible={false}
                        value={pageSize}
                        onChange={(event) => changePageSize(event.target.value)}
                        superSmall />
                </div>
                <p style={{ 'display': 'inline-block', width: '74px' }}>resultaten</p>
            </div>
        </Col > : null;
    return (
        <div className="l-grid__col:12/12">
            <div style={{ margin: containerMargin ? containerMargin : "0 0 50px 0" }}>
                {title || changePageSize ?
                    <div className="u-clear l-grid">
                        <Col style={{ 'marginLeft': '0px' }} size={6} className="u-display:none@to:viewport-4">
                            <p style={{ 'color': '#4ba144 ', 'marginTop': '20px', 'marginLeft': '0px' }}>{title}</p>
                        </Col>
                        {pageSizePicker}
                    </div> : null
                }
                <div className="sb-styles:padding">
                    <table style={{ display: "table", marginLeft: 'auto', marginRight: 'auto' }} id={id} className={"c-table"} >
                        {headers ? <thead className="c-table__header">
                            <tr className="c-table__row">
                                {headers.map((header, i) => {
                                    return getTableHeader(header, i);
                                })}
                            </tr>
                        </thead> : null}
                        <tbody className="c-table__body">
                            {children}
                        </tbody>
                    </table>
                </div>
                <br />
                {newPaging()}
            </div>
        </div>);
};

Table.defaultProps = {
    type: 'regular',
    headers: [],
    headerSizes: [],
    maxHeight: 0,
    pageSize: 20,
    totalPages: 0,
    currentPage: 1,
    centeredColumns: []
};

Table.propTypes = {
    ignoreLastItemStyling: PropTypes.bool,
    columnIndexesToHideWhenResponsive: PropTypes.array,
    narrowHeaders: PropTypes.bool,
    headers: PropTypes.array,
    headerSizes: PropTypes.array,
    type: PropTypes.string,
    maxHeight: PropTypes.number,
    children: PropTypes.node,
    style: PropTypes.object,
    onClickHeader: PropTypes.func,
    sortableColumns: PropTypes.array,
    onPageChange: PropTypes.func,
    pageSize: PropTypes.number,
    totalPages: PropTypes.number,
    currentPage: PropTypes.number,
    activePage: PropTypes.number,
    id: PropTypes.string,
    changePageSize: PropTypes.func,
    totalItems: PropTypes.number,
    title: PropTypes.string,
    containerMargin: PropTypes.string,
    setMinWidth: PropTypes.bool,
    centeredColumns: PropTypes.array
};
export default Table;